import { noop } from "lodash";
import type { PreviewComponents } from "../../../types";
import { InstallmentsLines } from "../InstallmentsLines";
import { Lines } from "../Lines";

export const installmentsVariant: PreviewComponents = [
  [InstallmentsLines.HeaderLine, noop],
  [InstallmentsLines.RegularPriceLine, noop],
  [InstallmentsLines.DiscountLine, noop],
  [Lines.TaxLine, noop],
  // Next monthly payment on
  // One time payment on
  [InstallmentsLines.SubtotalLine, noop],
];
